import React from 'react';
import { withErrorBoundary } from '@justgiving/error-boundary';

import TeamsPage from '../TeamsPage/TeamsPage';
import CampaignPage from '../CampaignPage/CampaignPage';
import AuctionPage from '../AuctionPage/AuctionPage';
import ErrorPageWrapper from '../ErrorPage/ErrorPageWrapper';
import componentDidCatch from '../../utils/componentDidCatch';
import { PageMetaContext } from '../../context/PageMetaContext';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import FundraisingPage from '../FundraisingPage/FundraisingPage';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';
import clientConfig from '../../client/config';
import { usePageOwner } from '../../hooks/usePageOwner';

export function PageType() {
  const {
    isPreview,
    currentUrl,
    pageType,
    error,
    pageShortName,
  } = useNotNullableContext(PageMetaContext);
  const { isUserLoggedIn } = useAuthenticateUser();
  const { isCheckingPageOwner, data } = usePageOwner();

  if (isPreview && !isUserLoggedIn) {
    window.location.assign(`${clientConfig.loginUrl}${encodeURI(currentUrl)}`);
    return null;
  }

  if (isPreview && !isCheckingPageOwner && !data?.legacyId) {
    return <ErrorPageWrapper status={404} messageKey={'page.error404'} />;
  }

  if (error) {
    return (
      <ErrorPageWrapper status={error.status} messageKey={error.messageKey} />
    );
  }

  if (isPreview && isCheckingPageOwner) {
    return null;
  }

  if (
    clientConfig.flags.enableOtgAuction &&
    pageShortName === 'otg-2020-auction'
  ) {
    console.log('auction page!');
    return <AuctionPage />;
  }

  if (pageType === 'team') {
    return <TeamsPage />;
  }

  if (pageType === 'campaign') {
    return <CampaignPage />;
  }

  if (pageType === 'fundraising') {
    return <FundraisingPage />;
  }

  if (pageType === 'one_page') {
    return <FundraisingPage />;
  }

  return null;
}

export default withErrorBoundary(
  PageType,
  <ErrorPageWrapper />,
  componentDidCatch,
);
